import React from 'react';
import PropTypes from 'prop-types';
import Links from 'layoutComponents/Links';
import Logout from 'layoutComponents/Logout';
import * as statusActionsCreator from 'actions/statusActions';
import * as messageActionsCreator from 'actions/messageActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Divider from 'material-ui/Divider';
import { withRouter } from 'react-router-dom';

const MainNavigation = (props) => {

    const { toggleDrawer, statusActions, user, techData, messageActions } = props;

    const userId = user.get('userId');

    const statusList = techData.getIn(['techs', userId, 'status']);
    const isFieldAdmin = user.get('isFieldAdmin');

    let toggelLeftDrawer;

    if (!toggleDrawer) {
        toggelLeftDrawer = () => { };
    } else {
        toggelLeftDrawer = () => {
            toggleDrawer('leftDrawer');
        };
    }

    let fieldAdminLinks = [<Links
        key="techSearch"
        onTouchTap={toggelLeftDrawer}
        isMenu
        linkKey="techSearch"
        className="wow-fst-sidebar-link" />,
    <Links
        key="workOrderTransfer"
        onTouchTap={toggelLeftDrawer}
        isMenu
        linkKey="workOrderTransfer"
        className="wow-fst-sidebar-link" />
    ];

    let logoutButton = (<Logout
        messageActions={messageActions}
        statusActions={statusActions}
        user={user}
        isMenuItem
        className="wow-fst-sidebar-link"
        toggleDrawer={toggelLeftDrawer}
        history={props.history}
    />);

    if (statusList) {
        const hasOnJobOrEnRouteStatus = statusList.find((statusItem) => {
            return statusItem.get('status') === 'onjob' || statusItem.get('status') === 'enroute' || statusItem.get('status') === 'onbreak';
        });

        if (hasOnJobOrEnRouteStatus) {
            logoutButton = null;
        }
    }
    if (!isFieldAdmin) {
        fieldAdminLinks = null;
    }

    // <Links onTouchTap={toggelLeftDrawer} isMenu linkKey="emergency"
    // className="wow-fst-sidebar-link"/>

    return (
        <span>
            <Links
                onTouchTap={toggelLeftDrawer}
                isMenu
                linkKey="myRoute"
                className="wow-fst-sidebar-link" />

            {fieldAdminLinks}
            <Links
                onTouchTap={toggelLeftDrawer}
                isMenu
                linkKey="techHistorySearch"
                className="wow-fst-sidebar-link" />
            <Links
                onTouchTap={toggelLeftDrawer}
                isMenu
                linkKey="inventory"
                className="wow-fst-sidebar-link" />

            <Links
                onTouchTap={toggelLeftDrawer}
                isMenu
                linkKey="equipmentSearch"
                className="wow-fst-sidebar-link" />

            <Links
                onTouchTap={toggelLeftDrawer}
                isMenu
                linkKey="equipmentTransfer"
                className="wow-fst-sidebar-link" />

            {logoutButton}

            <Divider />
            <Links
                onTouchTap={toggelLeftDrawer}
                isMenu
                linkKey="settings"
                className="wow-fst-sidebar-link" />
        </span>
    );
};
MainNavigation.propTypes = {
    toggleDrawer: PropTypes.func,
    statusActions: PropTypes.object,
    user: PropTypes.object,
    techData: PropTypes.object,
    messageActions: PropTypes.object,
    history: PropTypes.object
};

function mapDispatchToProps(dispatch) {
    return {
        statusActions: bindActionCreators(statusActionsCreator, dispatch),
        messageActions: bindActionCreators(messageActionsCreator, dispatch)
    };
}

function mapStateToProps(state) {
    return {
        user: state.get('user'),
        techData: state.get('techData'),
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(MainNavigation));


// WEBPACK FOOTER //
// ./src/components/layout/MainNavigation.js